import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource, InputBaseModel } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { InputIds } from '../../misc';
import { useAppStore } from '../../stores';

const LimitTypeInput: InputWithSource = ({ input }) => {
    const { nodesStore } = useAppStore();

    const node = nodesStore.getNodeByInputGuid(input.guid);

    // Filter options to exclude already-selected limit types (except the current input's value)
    let filteredOptions = input.sourceProvider.options;

    if (node) {
        const allLimitTypeInputs = node
            .getInputsAtSameLevel(input.guid)
            .filter((i: InputBaseModel) => i.id.startsWith(InputIds.Limits.LimitType));

        const selectedValues = allLimitTypeInputs
            .filter((i: InputBaseModel) => i.guid !== input.guid && i.value) // Exclude current input and empty values
            .map((i: InputBaseModel) => i.value as string);

        filteredOptions = input.sourceProvider.options.filter(option => !selectedValues.includes(option.value));
    }

    return <GenericSelect input={input} label={input.name} options={filteredOptions} />;
};

LimitTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(LimitTypeInput);
